
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 21.748a3.016 3.016 0 01-2.902-2.25h-6.197a3.016 3.016 0 01-2.902 2.25c-1.654 0-3-1.346-3-3s1.346-3 3-3c1.37 0 2.564.947 2.902 2.25h6.197A3.016 3.016 0 0121 15.748v-3a.75.75 0 00-.75-.75h-3.242l-1.312 3.278a.747.747 0 01-.696.472h-2.062a.75.75 0 010-1.5h1.554l2.511-6.279a.747.747 0 01.975-.417.745.745 0 01.411.401.742.742 0 01.007.574l-.789 1.971h2.642a2.252 2.252 0 012.25 2.25v3.406a3.017 3.017 0 011.5 2.594 3.002 3.002 0 01-2.999 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.672-1.5-1.5-1.5zm-12 0c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.672-1.5-1.5-1.5z"}}),_c('path',{attrs:{"d":"M5.233 15.748a3.725 3.725 0 01-3.591-2.673L.032 7.714a.754.754 0 01.117-.664.754.754 0 01.601-.302h12c.236 0 .461.113.602.302.141.19.185.438.117.664l-2.25 7.499a.745.745 0 01-.718.535H5.233zm-2.155-3.103a2.236 2.236 0 002.155 1.603h4.71l1.8-6H1.759l1.319 4.397zM10.653 5.998a.75.75 0 01-.65-.376 3.768 3.768 0 00-1.379-1.379 3.746 3.746 0 00-5.121 1.379.753.753 0 01-.651.376.745.745 0 01-.723-.555.74.74 0 01.074-.569 5.214 5.214 0 013.185-2.45c.45-.122.912-.183 1.372-.183a5.253 5.253 0 014.542 2.633c.1.173.126.376.074.569a.745.745 0 01-.723.555z"}})])
          )
        }
      }
    